import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VERIFICATION_STATE } from '../constants';
import { startPreprocessImport } from '../store/actions/verification';
import ImportPreprocess from '../import_loading/import_preprocess';
import Verification from '../import_loading/verification';
import { getImportRequest } from '../store/selectors';
import { setVerificationLabels, setVerificationState } from '../store/actions/verification';
import { isPreprocessRunning } from '../store/verification_selectors';

const successMessages = {
  header: 'Your data has been',
  headerHighlight: 'verified!',
  progressing: 'Verification complete.'
};

export function Mapping({
  importRequest,
  preprocessRunning,
  setVerificationLabels,
  setVerificationState,
  startPreprocess
}) {
  const [startProgressbar, setStartProgressBar] = useState(false);

  useEffect(() => {
    if (preprocessRunning) return;
    setStartProgressBar(true);
  }, [preprocessRunning]);

  useEffect(() => {
    setVerificationState(VERIFICATION_STATE.IN_PROGRESS);
    setVerificationLabels({
      footer: 'You will be notified by email when verification is complete.',
      progressing: 'Verifying data files...'
    });
  }, []);

  useEffect(() => {
    startPreprocess();
  }, []);

  return (
    <div className="container new-import-verfication">
      {startProgressbar && <ImportPreprocess importStatus={['mapping_files']} successMessages={successMessages} />}
      <Verification redirect={`/${importRequest.id}/map`} />
    </div>
  );
}

Mapping.propTypes = {
  importRequest: PropTypes.object.isRequired,
  preprocessRunning: PropTypes.bool.isRequired,
  setVerificationLabels: PropTypes.func.isRequired,
  setVerificationState: PropTypes.func.isRequired,
  startPreprocess: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state),
  preprocessRunning: isPreprocessRunning(state)
});

const mapDispatchToProps = {
  startPreprocess: startPreprocessImport,
  setVerificationLabels,
  setVerificationState
};

export default connect(mapStateToProps, mapDispatchToProps)(Mapping);
